<template>
  <Row id="EmployeeEntryRecord">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.EmployeeEntryRecordManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('employeeEntryRecord.name.search')" name="search">
                  <Input :placeholder="$t('employeeEntryRecord.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <!-- <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.field.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="0">{{ $t('public.placeholder.please_select') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.status.1') }}</SelectOption>
                    <SelectOption :value="2">{{ $t('public.status.2') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              <Col :xs="24" :sm="12" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>&nbsp;
                <Button type="primary" @click="new_join_report">{{$t('employeeEntryRecord.name.new_join_report')}}</Button>&nbsp;
                <Button type="primary" @click="term_report">{{$t('employeeEntryRecord.name.term_report')}}</Button>&nbsp;

              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idEmpEntRec" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <!-- <Button v-if="checkPermission('EmployeeEntryRecordManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button> -->
              </span>
            </template>
            <template #action="{text}">
              <div>
                <!-- <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('EmployeeEntryRecordManage.Edit')" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('EmployeeEntryRecordManage.Delete')" type="primary" danger size="small" @click="del(text.idEmpEntRec)">{{$t("public.name.del")}}</Button>
                </div> -->
                <Dropdown :trigger="['click']">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="detail(text)">{{$t('public.name.detail')}}</MenuItem>
                      <MenuItem @click="edit(text)">{{$t('public.name.edit')}}</MenuItem>
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <EmployeeEntryRecordDetail ref="refEmployeeEntryRecordDetail"></EmployeeEntryRecordDetail>
    <EmployeeEntryRecordEdit ref="refEmployeeEntryRecordEdit" @updateList="get_list"></EmployeeEntryRecordEdit>
    <NewJoinReport ref="refNewJoinReport"></NewJoinReport>
    <TermReport ref="refTermReport"></TermReport>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { EmployeeEntryRecordList } from "@/api/EmployeeEntryRecordList";
import { EmployeeEntryRecordDelete } from "@/api/EmployeeEntryRecordDelete"
import EmployeeEntryRecordDetail from "@/components/Home/EmployeeEntryRecordDetail";
import EmployeeEntryRecordEdit from "@/components/Home/EmployeeEntryRecordEdit";
import NewJoinReport from "@/components/Home/NewJoinReport";
import TermReport from "@/components/Home/TermReport";
import moment from "moment";

export default {
  name: "EmployeeEntryRecordManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    EmployeeEntryRecordDetail,
    EmployeeEntryRecordEdit,
    NewJoinReport,
    TermReport,
  },
  data() {
    return {
      searchForm: {
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          { title: this.$t("employeeEntryRecord.table.id_emp_ent_rec"), fixed: "left", dataIndex: "idEmpEntRec", key: "idEmpEntRec" },
          { title: this.$t("employee.table.nick_name"), dataIndex: "employeeNickName", key: "employeeNickName" },
          { title: this.$t("employeeEntryRecord.table.id_emp"), dataIndex: "employeeNameTw", key: "employeeNameTw" },
          { title: this.$t("employee.table.name_en"), dataIndex: "employeeNameEn", key: "employeeNameEn" },
          { title: this.$t("employeeEntryRecord.table.entry_date"), dataIndex: "entryDate", key: "entryDate" },
          { title: this.$t("employeeEntryRecord.table.term_date"), dataIndex: "termDate", key: "termDate" },
          { title: this.$t("employeeEntryRecord.table.term_remark"), dataIndex: "termRemark", key: "termRemark" },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
        employeeList: [],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new EmployeeEntryRecordList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      // if (this.searchForm.status != 0) getData.status = this.searchForm.status
      // if (this.searchForm.order != "") getData.order = this.searchForm.order
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
            //如果當前處於不是第一頁，但是又沒有數據的情況，則把頁面設置為1，並重新請求
            if(this.list.length == 0 && this.tablePagination.current != 1){
              this.tablePagination.current = 1;
              this.get_list();
            }
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refEmployeeEntryRecordEdit.addShow();
    },
    detail(obj) {
      this.$refs.refEmployeeEntryRecordDetail.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refEmployeeEntryRecordEdit.editShow(obj);
    },
    new_join_report(){
      this.$refs.refNewJoinReport.show();
    },
    term_report(){
      this.$refs.refTermReport.show();
    },
    del(idEmpEntRec) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new EmployeeEntryRecordDelete();
          api.post({ idEmpEntRec: idEmpEntRec }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.searchForm = {
        // search: "",
        // status: 0,
        // order: "",
      }
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/employeeEntryRecord.less");
</style>